<template>
    <div class="container">
        <div class="tabs" :style="{marginTop: '-30px', marginLeft: '-30px'}">
            <ul>
                <li :class="{'is-active': isActive == 'online'}" @click="Tabs('online')">
                    <a>ໂປຮໂມຮຊັ່ນ ເປີດຕອນນີ້</a>
                </li>
                <li @click="Tabs('offline')" :class="{'is-active': isActive == 'offline'}">
                    <a>ໂປຮໂມຮຊັ່ນ ປິດເເລ້ວ</a>
                </li>
            </ul>
        </div>

        <PromotionOnline v-if="isActive == 'online'"/>
        <PromotionOffline v-else/>
    </div>
</template>

<script>
import PromotionOnline from './List-Promotion-Online';
import PromotionOffline from './List-Promotion-Offline';

export default {
    components:{
        PromotionOnline,
        PromotionOffline
    },

    data:()=>({
        isActive: false,
    }), 

    methods:{
        Tabs(value){
            this.isActive = value;
            this.$router.push({name: 'tab.list.promotion', query:{tab: value}});
        }
    },
    created(){
        if(this.$route.query.tab == 'online'){
            this.isActive = 'online';
        }else if(this.$route.query.tab == 'offline'){
            this.isActive = 'offline';
        }else{
            this.isActive = 'online';
        }
    }
}
</script>

<style>

</style>